export const queryMailAddress = "admin@onegrad.ai";

export const tiers = {
  STARTER: "STARTER",
  ACHIEVER: "ACHIEVER",
  MENTORED: "MENTORED",
};

export const tierNames = {
  [tiers.STARTER]: "Starter",
  [tiers.ACHIEVER]: "Achiever",
  [tiers.MENTORED]: "Mentored",
};

export const paymentKeys = {
  ACHIEVER_MEMBERSHIP: "ACHIEVER_MEMBERSHIP",
  MENTORED_MEMBERSHIP: "MENTORED_MEMBERSHIP",
  ONEGRAD_REP_APPOINTMENT: "ONEGRAD_REP_APPOINTMENT",
  ONEGRAD_AI_TOKENS: "ONEGRAD_AI_TOKENS",
};

export const tierToPaymentKey = {
  [tiers.ACHIEVER]: paymentKeys.ACHIEVER_MEMBERSHIP,
  [tiers.MENTORED]: paymentKeys.MENTORED_MEMBERSHIP,
};

export const LOCATION_INDIA = "INDIA";
export const LOCATION_USA = "USA";
